import React from 'react'
import {
  SwipeableDrawer,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useNavigate } from 'react-router-dom'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import { FloatingSocialButtonRow } from '../SocialNetw/FloatingSocialButtonRow'

interface RightDrawerProps {
  isOpen: boolean
  toggleDrawer: (
    open: boolean
  ) => (event: React.KeyboardEvent | React.MouseEvent) => void
}

const Menu: React.FC<RightDrawerProps> = ({ isOpen, toggleDrawer }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')) // Check if screen is small
  const navigate = useNavigate() // Allows programmatic navigation

  const menuItems = [
    { label: 'Home', path: '/' },
    { label: 'About Us', path: '/aboutUs' },
    { label: 'Our Games', path: '/ourGames' },
    { label: 'News', path: '/news_blog' },
    // { label: 'Contact Us', path: '/contactUs' },
  ]

  const handleNavigation = (path: string) => {
    navigate(path) // Navigate to the selected path
    toggleDrawer(false)(null as any) // Close the drawer
  }

  return (
    <SwipeableDrawer
      anchor='right'
      open={isOpen}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      sx={{
        '& .MuiDrawer-paper': {
          borderLeft: '1px solid rgba(255, 255, 255, 0.18)',
          background: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(75px)',
          width: 'fit-content',
          height: '100vh',
          padding: '1.19rem',
          flexShrink: 0,
          [theme.breakpoints.down('sm')]: {
            width: '100vw',
            padding: '0 !important',
          },
        },
      }}
      ModalProps={{
        keepMounted: true, // Improve performance on mobile
      }}
      // variant={isMobile ? 'temporary' : 'permanent'}
    >
      <Box
        sx={{
          width: isMobile ? '100vw' : '26.875rem',
          position: 'relative',
        }}
        role='presentation'
        onClick={isMobile ? toggleDrawer(false) : undefined} // Close on click only for mobile
        onKeyDown={isMobile ? toggleDrawer(false) : undefined}
        // onClick={toggleDrawer(false)}
        // onKeyDown={toggleDrawer(false)}
      >
        <IconButton
          sx={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            fontSize: 20,
          }}
          onClick={isMobile ? toggleDrawer(false) : undefined}
        >
          <CloseIcon fontSize='large' sx={{ color: '#4caf50' }} />
        </IconButton>
        <List sx={{ padding: '20px' }}>
          {menuItems.map(item => (
            <ListItem key={item.label} disablePadding>
              <ListItemButton
                onClick={() => handleNavigation(item.path)} // Trigger navigation and close drawer
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <ListItemText
                  primary={
                    <span
                      style={{
                        textDecoration: 'none',
                        color: 'white',
                        fontFamily: '"Proxima Nova", sans-serif',
                        fontSize: '2.625rem',
                        fontWeight: 400,
                        textTransform: 'uppercase',
                      }}
                    >
                      {item.label}
                    </span>
                  }
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
      <FloatingSocialButtonRow />
    </SwipeableDrawer>
  )
}

export default Menu
